import { createAction, props } from '@ngrx/store';

export enum AppointmentActions {
  SetBookedAppointments = '[Appointments] Set Boooked',
}

export const SetBookedAppointments = createAction(
  AppointmentActions.SetBookedAppointments,
  props<{ bookedAppointments: any[] }>(),
);
